import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from "@mui/icons-material/Facebook";
import HomeIcon from '@mui/icons-material/Home';
import { Routes } from 'src/utils/enums';
import chiropracticTherapyImg from "../images/img_2.jpg";
import chiropracticTherapyImg2 from "../images/img_4.jpg";
import physicalTherapyImg from "../images/img_1.jpg";
import sportInjuries from "../images/img_5.png"

export const bannerData = [
    {
        title: "Visit our Location",
        subTitle: "Bat Tala Serampore (Beside Khadim's Showroom)",
        icon: HomeIcon
    },
    {
        title: "Call us today",
        subTitle: "+91 9830425103",
        icon: CallIcon
    },
    {
        title: "Send us a message",
        subTitle: "drabhijitmaji@gmail.com",
        icon: EmailIcon
    },
    {
        title: "Opening hours",
        subTitle: "Mon - Sat 9AM - 9PM",
        icon: AccessTimeIcon
    }
];

export const servicesData = (isWhatWeOffer: boolean) => {
    return [
        ...isWhatWeOffer ? [{
            title: "What We Offer",
            description: {
                content1: {
                    heading: "We provide Physical Therapy services",
                    title: "At our clinic, we offer a comprehensive range of therapies tailored to support your recovery, enhance your mobility, and improve your overall well-being.\n Physical Therapy is at the heart of our services, helping patients restore movement, reduce pain, and regain strength after injuries, surgeries, or chronic conditions. Each plan is customized to meet individual needs and goals.\n Our Massage Therapy provides both therapeutic and relaxation benefits. Whether you’re dealing with muscle stiffness, stress, or circulatory issues, our licensed massage therapists use targeted techniques to relieve tension and promote deep relaxation.\n With Chiropractic Therapy, we focus on spinal alignment and nervous system function. This treatment is ideal for addressing back pain, posture problems, headaches, and joint discomfort. Gentle spinal adjustments help restore balance and reduce discomfort without invasive procedures.\n We also provide rehabilitation for Work Injuries, ensuring a safe and effective recovery process. From repetitive strain injuries to post-accident rehabilitation, our team supports your return to work with confidence and reduced risk of reinjury.\n Our Clinical Pilates sessions combine movement and breath to build core strength, flexibility, and body awareness. Under the guidance of trained professionals, Pilates supports recovery, corrects posture, and is excellent for injury prevention.\n For athletes, our Sport Injuries therapy focuses on rapid and safe return to activity. Whether you're a professional or recreational athlete, we offer tailored programs for common sports-related injuries such as sprains, tendonitis, or muscle tears.\n Each therapy we offer is rooted in evidence-based practice, guided by compassionate care, and designed to help you move freely and live pain-free. We are committed to supporting you at every stage of your health journey."
                },
                content2: {
                    heading: "Our services included all types and sizes",
                    title: "We take a team approach and will consult with your employer and case manager, if necessary. Throughout your treatment, we will work hard to help you return to all normal functional activities. When you are ready for discharge, you will receive a personalized home exercise-program to allow you to stay healthy. \n Our experienced team of physiotherapists will perform a comprehensive assessment, including postural and biomechanical assessments, to diagnose your problem."
                },
            },
            image: "",
            buttonName: "See all services",
        }] : [],
        {
            title: "Physical Therapy",
            description: {
                content1: {
                    heading: "We provide Physical Therapy services",
                    title: "Your personal physical therapy begins with a comprehensive evaluation of functional limitations and areas of pain. Our team of expert physical therapists will design a treatment plan based on your work-related needs and goals. We take a team approach and will consult with your employer and case manager, if necessary. Throughout your treatment, we will work hard to help you return to all normal functional activities. When you are ready for discharge, you will receive a personalized home exercise program to allow you to stay healthy on the job, further enhance your rehabilitation."
                },
                content2: {
                    heading: "Our services included all types and sizes",
                    title: "We take a team approach and will consult with your employer and case manager, if necessary. Throughout your treatment, we will work hard to help you return to all normal functional activities. When you are ready for discharge, you will receive a personalized home exercise-program to allow you to stay healthy. \n Our experienced team of physiotherapists will perform a comprehensive assessment, including postural and biomechanical assessments, to diagnose your problem."
                },
            },
            image: physicalTherapyImg,
            buttonName: "Find out more",
            link: "services/physical-therapy"
        },
        {
            title: "Chiropractic Therapy",
            subTitle: "Chiropractic is a non-invasive, hands-on health care discipline that focuses on the neuro-musculoskeletal system. Chiropractors practice a manual approach. Doctors of Chiropractic are specifically trained to detect and correct problems in the spine, often before the patient is even aware they exist.",
            description: {
                content1: {
                    heading: "What is Wellness Chiropractic?",
                    title: "More often than not, when we tell someone that we are a chiropractic office, they immediately associate our vocation with neck and/or back pain. What many do not realize, however, is that chiropractic is a health care modality that provides significantly more than just a solution for pain.\n Chiropractic is a lifestyle that involves all aspects of wellness, including exercise, nutrition, personal development, and stress relief. We have been fortunate to work with people from all walks of life (including newborns, children, and adolescents) and the outcome has been miraculous."
                },
                content2: {
                    heading: "Speciality Pilates equipment",
                    title: "We use a mix of specialised equipment including Pilates reformers, trapeze tables, fit balls, foam rollers and more. This equipment is designed specifically for clinical Pilates, promoting correct technique, appropriate resistance levels, and targeted exercises so you can really work your key areas and see results.\n Our instructors also spend extra time teaching key muscle contraction techniques, which enables you to get more out of every Pilates workout session."
                },
            },
            image: chiropracticTherapyImg,
            buttonName: "Find out more",
            link: "services/chiropractic-therapy"
        },
        {
            title: "Sport Injuries",
            subtitle: "Targeted rehabilitation to help athletes recover from injuries, regain strength, and return to peak performance.",
            description: {
                content1: {
                    heading: "Customized Recovery Plans for Every Athlete",
                    title: "Whether you're a professional or recreational athlete, our sport injury rehabilitation programs are designed to get you back in the game safely and efficiently. We treat sprains, strains, tendonitis, ligament injuries, and more using evidence-based techniques tailored to your sport and goals."
                },
                content2: {
                    heading: "Speed, Strength & Safety",
                    title: "Our team uses a multidisciplinary approach including physiotherapy, manual therapy, and sport-specific exercises to improve strength, flexibility, and prevent reinjury. You'll also receive training on warm-up and cool-down routines to keep you performing at your best."
                },
            },
            image: sportInjuries,
            buttonName: "Find out more",
            link: "services/sport-injuries"
        },
        {
            title: "Rehab",
            subtitle: "Personalized rehabilitation programs to restore movement, strength, and independence after injury or surgery.",
            description: {
                content1: {
                    heading: "Comprehensive Functional Recovery",
                    title: "Our rehabilitation services focus on restoring optimal physical function following surgeries, fractures, or chronic musculoskeletal conditions. We create step-by-step programs tailored to each individual's needs and goals for complete recovery."
                },
                content2: {
                    heading: "Holistic & Goal-Oriented",
                    title: "We emphasize pain management, muscle re-education, and progressive strengthening. Our therapists monitor your progress closely to ensure consistent improvement, helping you regain control and confidence in everyday life."
                },
            },
            image: sportInjuries,
            buttonName: "Find out more",
            link: "services/rehab"
        },
        {
            title: "Work Injuries",
            subtitle: "Helping you recover from workplace injuries and return to work safely and confidently.",
            description: {
                content1: {
                    heading: "Safe Return to Work Starts Here",
                    title: "We specialize in treating repetitive strain injuries, postural stress, and trauma-related issues caused at the workplace. Our programs aim to reduce downtime, restore function, and prevent recurrence of injury through functional therapy."
                },
                content2: {
                    heading: "Collaboration for Effective Recovery",
                    title: "We work closely with your employer, insurer, and case manager to develop a customized return-to-work plan. Our focus is on restoring your physical capabilities while ensuring compliance with occupational safety guidelines."
                },
            },
            image: sportInjuries,
            buttonName: "Find out more",
            link: "services/work-injuries"
        },
        {
            title: "Dry Needling",
            subtitle: "A modern technique to relieve muscular pain and tension by targeting trigger points with thin, sterile needles.",
            description: {
                content1: {
                    heading: "Trigger Point Therapy Made Effective",
                    title: "Dry needling helps release knots and improve blood flow in deep muscles, often used in tandem with physiotherapy. It's a safe, minimally invasive method for reducing chronic pain and improving range of motion."
                },
                content2: {
                    heading: "Fast Relief for Persistent Pain",
                    title: "Conditions like back pain, neck stiffness, shoulder tension, and even headaches can benefit from dry needling. Our certified practitioners ensure precise application for effective pain relief and faster recovery."
                },
            },
            image: sportInjuries,
            buttonName: "Find out more",
            link: "services/dry-needling"
        },
        {
            title: "Myofascial Release",
            subtitle: "A hands-on technique that focuses on relieving tension and tightness in the myofascial tissues.",
            description: {
                content1: {
                    heading: "Release Tension, Restore Movement",
                    title: "Myofascial release therapy targets adhesions and restrictions in the connective tissue surrounding muscles and organs. It's particularly effective for chronic pain conditions, postural issues, and flexibility limitations."
                },
                content2: {
                    heading: "Gentle Yet Powerful",
                    title: "Our therapists apply gentle, sustained pressure to improve circulation, reduce pain, and promote healing. Regular sessions can help restore balance and function, especially in cases of fibromyalgia, sciatica, or post-surgical recovery."
                },
            },
            image: sportInjuries,
            buttonName: "Find out more",
            link: "services/myofascial-release"
        },
    ]
};

export const navbarMenu = [
    { title: "Home", link: Routes.LANDING_PAGE },
    {
        title: "Services", link: Routes.SERVICES_PAGE,
        subMenu: servicesData(false)
    },
    { title: "About", link: Routes.ABOUT_PAGE },
    // { title: "Blog", link: Routes.BLOG_PAGE },
    { title: "Contact", link: Routes.CONTACT_PAGE }
];


/** export const footerData = {
     title: "Subscribe Newsletter",
     subTitle: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
}; */

export const footerLinks = ["About Us", "Services", "Testimonials", "Contact Us"];

export const whyUsData = {
    title: "Why Choose Us",
    subTitle: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ut tenetur possimus nam totam, repellat expedita ullam amet velit.",
    image: physicalTherapyImg,
};



export const footerQuickLinks = [
    { title: "About Us", link: Routes.ABOUT_PAGE },
    { title: "Services", link: Routes.SERVICES_PAGE },
    // { title: "Our Blogs", link: Routes.BLOG_PAGE },
    { title: "Contact Us", link: Routes.CONTACT_PAGE }
];


export const footerContents = [
    {
        title: "Quick Links",
        content: footerQuickLinks
    },
    {
        title: "Services",
        content: servicesData(false)
    },
    {
        title: "Follow Us",
        icons: [
            {
                icon: FacebookIcon,
                link:"https://www.facebook.com/profile.php?id=100063669106447"
            },
            /** 
            {
                icon: TwitterIcon,
                link:""
            },
            {
                icon: InstagramIcon,
                link:""
            },
            {
                icon: LinkedInIcon,
                link:""
            }
                */
        ]
    },
    /** {
         title: "Subscribe Newsletter",
         subTitle: "Get expert insights on physical wellness, posture correction, injury recovery, and more. Subscribe now and be the first to know about new treatments and special discounts.",
         inputName: "Enter Email",
         buttonName: "Send"
    } */
]

export const specialOfferesGrid1Data = [
    {
        title: "Physical Therapy",
        subTitle: "Your personal physical therapy begins with a comprehensive evaluation of functional limitations and areas of pain. Our team of expert physical therapists will design a treatment plan based on your work-related needs and goals. We take a team approach and will consult with your employer and case manager, if necessary. Throughout your treatment, we will work hard to help you return to all normal functional activities. When you are ready for discharge, you will receive a personalized home exercise program to allow you to stay healthy on the job, further enhance your rehabilitation.",
        image: physicalTherapyImg,
        link: "services/physical-therapy"
    },
    {
        title: "Dry Needling",
        subTitle: "Dry needling is a therapeutic technique used to release muscle tightness and alleviate pain. It involves inserting fine needles into trigger points to improve function and mobility.",
        image: sportInjuries,
        link: "services/dry-needling"
    },
];

export const specialOfferesGrid2Data = [
    {
        title: "Chiropractic Therapy",
        subTitle: "Chiropractic is a non-invasive, hands-on health care discipline that focuses on the neuro-musculoskeletal system. Chiropractors practice a manual approach. Doctors of Chiropractic are specifically trained to detect and correct problems in the spine, often before the patient is even aware they exist.",
        image: chiropracticTherapyImg,
        link: "services/chiropractic-therapy"
    },
    {
        title: "Rehab",
        subTitle: "Personalized rehabilitation programs to restore movement, strength, and independence after injury or surgery.",
        image: chiropracticTherapyImg2,
        link: "services/rehab"
    },
];


export const chooseUsData = {
    title: 'Why Choose Us',
    subTitle: 'At Realign Healthcare, we are committed to helping you regain mobility, reduce pain, and improve your overall quality of life through expert physiotherapy care. Our highly qualified team creates personalized treatment plans tailored to your specific needs and goals, ensuring that each session is effective and meaningful. Using the latest equipment and evidence-based techniques, we provide hands-on, holistic care that focuses on long-term recovery and injury prevention. We pride ourselves on a patient-first approach — listening to your concerns, involving you in your treatment, and making your journey to better health as smooth and supportive as possible.',
    content: [
        { title: 'Happy Clients', target: 10, suffix: 'K' },
        { title: 'Years of Experience', target: 19, suffix: '' },
        { title: 'Satisfaction', target: 100, suffix: '%' },
    ]
};



